import React from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _isUndefined from 'lodash/isUndefined';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import SwitchMUI from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {RenderOrEmpty} from '../index';

import style from './style';

function Switch(props) {
  const {
    classes,
    switchClassName,
    disabled,
    label,
    // eslint-disable-next-line
    name,
    inputProps,
    isChecked,
    onChange,
    labelFormClassName,
    labelClassName,
  } = props;
  const switchClasses = {
    track: classNames(
      classes.switchBar,
      {
        [classes.switchBar_checked]: isChecked,
        [classes.switchBar_unchecked]: !isChecked,
      },
    ),
    thumb: classNames(
      {
        [classes.switch_checked]: isChecked && !disabled,
        [classes.switch_unchecked]: !isChecked && !disabled,
        [classes.switch_checked_disabled]: isChecked && disabled,
        [classes.switch_unchecked_disabled]: !isChecked && disabled,
      },
    ),
    switchBase: classNames(
      classes.switch,
      {
        [classes[switchClassName]]: !_isUndefined(switchClassName),
        [classes.switch_checked]: isChecked,
        [classes.switch_unchecked]: !isChecked,
      },
    ),
  };
  const labelFormClasses = {
    root: classNames(
      classes.formControl,
      {
        [classes[labelFormClassName]]: !_isUndefined(labelFormClassName),
      },
    ),
    label: classNames(
      classes.switch__label,
      {
        [classes[labelClassName]]: !_isUndefined(labelClassName),
      },
    ),
  };
  const inputProperties = {
    ...inputProps,
    name: name,
  };
  const SwitchComponent = (
    <SwitchMUI
    classes={switchClasses}
    checked={isChecked || _isEqual(isChecked, 'true')}
    disabled={disabled}
    inputProps={inputProperties}
    onChange={onChange}
    />
  );
  return (
    <>
      <RenderOrEmpty isShow={!_isUndefined(label)}>
        <FormControlLabel
          control={SwitchComponent}
          label={label}
          classes={labelFormClasses}
        />
      </RenderOrEmpty>
      <RenderOrEmpty isShow={_isUndefined(label)}>
        {SwitchComponent}
      </RenderOrEmpty>
    </>
  );
}

Switch.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  isChecked: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  inputProps: PropTypes.object,
  switchClassName: PropTypes.string,
  labelFormClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

Switch.defaultProps = {
  onChange: () => {},
  isChecked: false,
  disabled: false,
  inputProps: {},
  name: '',
  label: undefined,
  switchClassName: undefined,
  labelFormClassName: undefined,
  labelClassName: undefined,
};

export default withStyles(style)(Switch);
